/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface IssueChallengeRequest
 */
export interface IssueChallengeRequest {
    /**
     * どの sudo-mode 操作に対するチャレンジかを表す。 card_information=カード詳細, user_profile=メールアドレス変更, user_invitation=ユーザ招待/一括招待 
     * @type {string}
     * @memberof IssueChallengeRequest
     */
    'scope': IssueChallengeRequestScopeEnum;
}

export const IssueChallengeRequestScopeEnum = {
    cardInformation: 'card_information',
    userProfile: 'user_profile',
    userInvitation: 'user_invitation'
} as const;

export type IssueChallengeRequestScopeEnum = typeof IssueChallengeRequestScopeEnum[keyof typeof IssueChallengeRequestScopeEnum];


